/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react';
import styled from '@emotion/styled';
import { useStaticQuery, graphql } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import AnimatedSection from '../../components/AnimatedSection';
import CommonSection from "../../components/CommonSection";
import { parseHTML } from '../../functions/common'
import * as breakpoint from '../../styles/breakpoints.module.scss';

const IntroductionSection = () => {
  const { t } = useLocalization();
  const data = useStaticQuery(graphql`
    query FrameStickerIntroduction {
      gpose_1 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_1.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_2 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_2.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_3 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_3.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_4 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_4.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_5 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_5.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      gpose_6 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_6.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
    }
  `);


  return (
    <React.Fragment>
      <AnimatedSection>
        <CommonSection css={css`
          > div {
            padding-top:0;
            padding-bottom:0;
            justify-content: center;
          }

          @media only screen and (max-width: ${breakpoint.smMax}){
            > div{
              padding-bottom:64px;
            }
          }

          @media only screen and (max-width: ${breakpoint.xsMax}){
            > div{
              padding-bottom:32px;
            }
          }
        `}>
          <DecoRow>
            <DecoFrame className="col_1">
              <GatsbyImage image={getImage(data[`gpose_5`])} alt="" />
            </DecoFrame>
            <DecoFrame className="col_2">
              <GatsbyImage image={getImage(data[`gpose_1`])} alt="" />
            </DecoFrame>
            <DecoFrame className="col_3">
              <GatsbyImage image={getImage(data[`gpose_6`])} alt="" />
            </DecoFrame>
            <DecoFrame className="col_4">
              <GatsbyImage image={getImage(data[`gpose_4`])} alt="" />
            </DecoFrame>
          </DecoRow>
          <Textbox>
            <DescText>
              {parseHTML(t('frame_sticker.page.display.description'))}
            </DescText>
            <DateText>
              {parseHTML(t('frame_sticker.frame_sticker.date.term'))}
            </DateText>
          </Textbox>
          
        </CommonSection>
      </AnimatedSection>
    </React.Fragment>
  );
}
 
export default IntroductionSection;

const DecoRow = styled.div`
  display:flex;
  justify-content:space-between;
  width:100%;
  max-width:1440px;
  margin:-48px auto 0;
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    flex-wrap:wrap;
    justify-content:center;
    margin:-32px auto 0;
    max-width:512px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:-16px -8px 0;
    width: auto;
  }
`

const DecoFrame = styled.div`
  width: 304px;
  height: auto;
  > div{
    width:100%;
    height:100%;
  }
  border-radius: 2px;
  overflow:hidden;
  border: 1px solid rgba(0,0,0,.1);
  box-sizing: border-box;
  position:relative;
  z-index: 1;

  transition: transform .3s;
  border-radius: 2px;
  
  /* Shadow / 1dp */
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);

  &:hover{
    z-index:10;
    /* Shadow / 2dp */
    box-shadow: 0px 6px 4px -4px rgba(0, 0, 0, 0.1), 0px 12px 8px -8px rgba(0, 0, 0, 0.05), 0px 24px 16px -16px rgba(0, 0, 0, 0.05);
  }

  &.col_1{
    transform: rotate(-8.2deg);
    &:hover{
      transform: scale(1.25) rotate(-8.2deg);
    }
  }
  &.col_2{
    transform: rotate(8.19deg);
    &:hover{
      transform: scale(1.25) rotate(8.19deg);
    }
  }
  &.col_3{
    transform: rotate(0);
    &:hover{
      transform: scale(1.25) rotate(0);
    }
  }
  &.col_4{
    transform: rotate(-5.44deg);
    &:hover{
      transform: scale(1.25) rotate(-5.44deg);
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    width:208px;
    margin:0 16px 32px;
    transform: none !important;
    &:hover{
      transform: scale(1.25) !important;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:128px;
    margin:0 8px 16px;
  }
`

const Textbox = styled.div`
  padding-top:48px;
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding-top:0;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding-top:16px;
  }
`

const DescText = styled.div`
  font-size: 20px;
  line-height: 32px;
  color: #444448;
  text-align:center;
  max-width:928px;
  margin:0 auto;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 14px;
    line-height: 24px;
    max-width: 608px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 12px;
    line-height: 20px;
  }
`

const DateText = styled.div`
  max-width: 928px;
  margin-left: auto;
  margin-right: auto;
  font-size: 28px;
  line-height: 40px;
  color: #D00F31;
  font-weight: 900;
  margin-top:32px;
  text-align:center;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 16px;
    line-height: 28px;
    margin-top:24px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 14px;
    line-height: 24px;
    margin-top:16px;
  }
`
